export default {
  common: {
    siteName: "AllChinaBuy Spreadsheet",
    siteTagline: "Fund, guider & ressourcer",
    disclaimer: "Uafhængig ressource — ikke tilknyttet AllChinaBuy",
    nav: {
      home: "Forside",
      categories: "Kategorier",
      guides: "Guider",
      shoppingGuide: "Købsguide",
      safety: "Sikkerhed",
    },
    lang: {
      label: "Sprog",
      en: "English",
      fr: "Français",
      da: "Dansk",
      de: "Deutsch",
    },
    buttons: {
      buyNow: "Køb nu",
      mainCta: "AllChinaBuy Spreadsheet",
      explore: "Udforsk",
      visitMain: "Besøg hovedsiden",
      readGuide: "Læs guiden",
      backHome: "Tilbage til forsiden",
      learnMore: "Læs mere",
    },
    categories: {
      shoes: "Sko",
      hoodies: "Hættetrøjer/Sweatshirts",
      tshirts: "T-shirts",
      jackets: "Jakker",
      pants: "Bukser/Shorts",
      headwear: "Hovedbeklædning",
      sets: "Sæt",
      underwear: "Undertøj/Underbukser",
      jersey: "Trøjer",
      accessories: "Tilbehør",
      bags: "Tasker",
      belts: "Bælter",
      perfumes: "Parfumer",
      other: "Andet",
    },
    footer: {
      about: "AllChinaBuy Spreadsheet er et uafhængigt informationshub, der hjælper købere med at opdage organiserede ressourcer, produktfund, købsguider, forsendelsestips og QC-oplysninger.",
      explore: "Udforsk",
      resources: "Ressourcer",
      home: "Forside",
      guide: "Komplet guide",
      categoriesLabel: "Kategorier",
      legal: "Juridisk",
      privacy: "Privatliv",
      terms: "Vilkår",
      affiliate: "Affiliate-oplysning",
      copyright: "Alle rettigheder forbeholdes.",
      independent: "Dette site er en uafhængig ressource og er ikke tilknyttet eller godkendt af AllChinaBuy.",
    },
  },
};